import ownerRezLogo from './images/ownerRezLogo.png';
import touchStayLogo from './images/touchStayLogo.png';
import stayFiLogo from './images/stayFiLogo.png';
import hospitableLogo from './images/hospitableLogo.svg';
import airbnbLogo from './images/airbnbLogo.png';
import guestyLogo from './images/guestyLogo.svg';
import guestyLiteDarkLogo from './images/GuestyLiteDarkLogo.png';
import lodgifyLogo from './images/lodgifyLogo.png';
import hostawayLogo from './images/HostawayLogo.png';
import turnoLogo from './images/turnoLogo.svg';
import hostfullyLogo from './images/hostfullyLogo.svg';
import hosttoolsLogo from './images/hosttoolsLogo.svg';
import {
  hostawayStepByStepInstructions,
  lodgifyStepByStepInstructions,
  ownerrezStepByStepInstructions,
} from './StepByStepSection/index.js';
import React from 'react';
import { INTEGRATION_INSTRUCTIONS } from '../../api/partners';

import {
  hospitableConnectApi,
  ownerRezApi,
  hospitableApi,
  turnoApi,
  hostfullyApi,
} from 'api/partners';

import { reverse } from 'utils/urls';
import { URLS } from 'components/Routes/urls';
import { IntegrationType } from 'api/types/partners';
import { IS_STAGING } from 'consts';

export const partnersData = {
  ownerrez: {
    name: IntegrationType.OWNERREZ,
    title: 'Get Started',
    copy: 'Learn how to import your OwnerRez properties with this video.',
    videos: [
      {
        id: '91GHpPJoE24',
        title: 'How it Works',
        start: 85,
      },
    ],
    heading: 'Quick-Start Instructions',
    quick_start_instructions: [
      '1) Click continue to connect your OwnerRez account.',
      '2) Choose which properties you’d like to create stores for, or create one store from your listings and later duplicate it to your liking.',
      '3) Add or edit products - don’t forget to update your descriptions!',
      '4) One finished, add your store link in your OwnerRez automated messages with custom code {PXHOSTCO}. We recommend sharing your store link at booking, a week before check-in, and at check-in.',
      <>
        <div>
          5) We recommend sharing your store link:
          <ul style={{ marginLeft: '30px' }}>
            <li>In your “Thanks for booking” message</li>
            <li>One week before check-in</li>
            <li>In your check-in notes</li>
            <li>For message examples, click Share on any Host Co store.</li>
          </ul>
        </div>
      </>,
      <>
        <div>
          <p style={{ marginBottom: '15px', fontWeight: 'bold' }}>
            Note on Early Check-In & Late Check-Out{' '}
          </p>{' '}
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your
          OwnerRez booking times, show you a visual reminder, and add notes in your booking notes
          field <b>unless your Host Co stores were created before May 14, 2025.</b>
          <p style={{ marginTop: '15px' }}>
            If your stores were created before this date, these early check-in and late check-out
            tiles will not sync with the OwnerRez calendar because older tile versions don’t include
            the required time fields. To fix this: replace your old tiles with the updated versions.
            <a
              href={`https://www.youtube.com/watch?v=vMtt_rK4Sgg`}
              target="_blank"
              rel="noreferrer"
              style={{ marginLeft: '5px' }}
            >
              Click here to learn more.
            </a>
          </p>
        </div>
      </>,
      INTEGRATION_INSTRUCTIONS(IntegrationType.OWNERREZ),
    ],
    bottom_heading: 'Step-by-Step Instructions',
    step_by_step_instructions: [
      '1) Click continue to connect your OwnerRez account.  Once you log in, click the button to authorize the Host Co:',
      <>
        <img src={ownerrezStepByStepInstructions.ownerrez_step1} />{' '}
      </>,
      '2) Choose which properties you’d like to create stores for, or link your existing stores to existing Host Co stores, or create one store from your listings and later duplicate it to your liking.',
      '3) Add or edit products - don’t forget to update your descriptions!',
      '4) Once finished, add your store links in your OwnerRez automated messages with custom field {PXHOSTCO}. We recommend sharing your store link at booking, a week before check-in, and at check-in. For message examples, click “Share”  on any Host Co store.',
      'Note: The integration will automatically add the matching store link to the correct property.  To check that your custom field is attached to the correct store, go to OwnerRez “settings”, and under “Workflow & Devices” look for “Custom Field Definitions”. Click this and select “PXHOSTCO”.  This will show each link that’s connected to each property. You can cross-reference the Host Co store link under the “Share Store” button in each store.',
      <>
        <img src={ownerrezStepByStepInstructions.ownerrez_step2} />{' '}
        <img src={ownerrezStepByStepInstructions.ownerrez_step3} />{' '}
      </>,
      '5) Make sure you are talking about your Host Co offers in your messages. To add a custom message in Owner Rez, click on “Settings” and then under “Messages,” look for  “Templates” to create a custom message where you’ll use {PXHOSTCO}.  You will also need to set up “Triggers,” which can be found next to the templates, to schedule when they go out.',
      <>
        <img src={ownerrezStepByStepInstructions.ownerrez_step4} />{' '}
        <img src={ownerrezStepByStepInstructions.ownerrez_step5} />{' '}
      </>,
      'To preview template messages with your Host Co link, navigate to Settings > Templates and select the template type you want to preview (Email, Channel, or SMS). After saving your template, click the Preview button at the top of the screen.',
      'For Channel Templates specifically, you can preview how your message will appear to guests and also select different properties and bookings from dropdown lists to see how the template renders with different guest information. Click Close to exit the preview.',
      <div key="ownerrez-step5">
        <b>Note on Early Check-In & Late Check-Out</b>
        <p style={{ marginTop: '15px' }}>
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your
          OwnerRez booking times, show a visual reminder, and add notes in your booking notes field
          unless your Host Co stores were created before May 14, 2025.
        </p>
        <p>
          If your stores were created before this date, these early check-in and late check-out
          tiles will not sync with the OwnerRez calendar because older tile versions don’t include
          the required time fields. To fix this, replace your old tiles with the updated versions.
          <a
            href={`https://www.youtube.com/watch?v=vMtt_rK4Sgg`}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px' }}
          >
            Click here to learn more.
          </a>
        </p>
      </div>,
      <>
        <img src={ownerrezStepByStepInstructions.ownerrez_step6} />{' '}
        <img src={ownerrezStepByStepInstructions.ownerrez_step7} />{' '}
      </>,
      <div key="ownerrez-step6">
        <b>Note: Only one Host Co account can be linked to one OwnerRez account.</b>
        <p style={{ marginTop: '15px' }}>
          To disconnect your OwnerRez and Host Co account, re-initiate the integration and use your
          new login for either OwnerRez or The Host Co. This will update the connection to your new
          account and remove the connection from your original account. For additional help, contact
          support@thehost.co
        </p>
      </div>,
    ],
    onContinue: () => ownerRezApi.authenticate(),
  },
  hospitableconnect: {
    name: IntegrationType.HOSPITABLE_CONNECT,
    title: 'Get Started',
    copy: 'Learn how to import your Airbnb listings with this video.',
    heading: 'Quick-Start Instructions',
    videos: [
      {
        id: 's3nJDVreGPY',
        title: 'How it Works',
      },
    ],
    quick_start_instructions: [
      '1) Click continue below to connect your Airbnb account to The Host Co. using Hospitable Connect.',
      '2) Choose which properties you want to create stores for.',
      '3) Add products to your new stores and start making money!',
      INTEGRATION_INSTRUCTIONS(IntegrationType.HOSPITABLE_CONNECT),
    ],
    onContinue: () => hospitableConnectApi.authenticate(),
  },
  hospitable: {
    name: IntegrationType.HOSPITABLE,
    title: 'Get Started',
    copy: 'Learn how to connect to your Hospitable account with this video.',
    videos: [
      {
        id: 'pAdyEKL_lR8',
        title: 'How it Works',
      },
    ],
    heading: 'Quick-Start Instructions',
    quick_start_instructions: [
      '1) Click continue below to connect your Hospitable account to The Host Co.',
      '2) Choose which properties you want to create stores for.',
      '3) Add products to your new stores and start making money!',
      INTEGRATION_INSTRUCTIONS(IntegrationType.HOSPITABLE),
    ],
    onContinue: () => hospitableApi.authenticate(),
  },
  guesty: {
    name: IntegrationType.GUESTY,
    title: 'Get Started',
    copy: 'Learn how to connect to your Guesty account with this video.',
    videos: [
      {
        id: 'Aqkjvi-VmTM',
        title: 'How it Works',
        start: 84,
      },
    ],
    heading: 'Quick-Start Instructions',
    quick_start_instructions: [
      '1) Click continue below to connect your Guesty account.',
      '2) You’ll be asked for a Guesty integration token. If you don’t have a token we’ll show you where to generate one.',
      '3) Paste your integration token into the provided form (required only once).',
      '4) Choose which properties you’d like to create stores for and modify stores to your liking.',
      '5) Each store link is pre-populated in Guesty and can be added to your outgoing messages by hitting "+Add variable" and selecting "HostCo".',
      <>
        <div>
          6) Share your Host Co store links in your outgoing Guesty messages. We recommend sharing
          your store link:
          <ul style={{ marginLeft: '30px' }}>
            <li>In your “Thanks for booking” message</li>
            <li>One week before check-in</li>
            <li>In your check-in notes</li>
            <li>For message examples, click Share on any Host Co store.</li>
          </ul>
        </div>
      </>,
      <>
        <div>
          <p style={{ marginBottom: '15px', fontWeight: 'bold' }}>
            Note on Early Check-In & Late Check-Out{' '}
          </p>{' '}
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your Guesty
          booking times, show you a visual reminder, and add notes in your booking notes field,{' '}
          <b>unless your Host Co stores were created before May 14, 2025.</b>
          <p style={{ marginTop: '15px' }}>
            If your stores were created before this date, these early check-in and late check-out
            tiles will not sync with the Guesty calendar because older tile versions don’t include
            the required time fields. To fix this: replace your old tiles with the updated versions.
            <a
              href={`https://www.youtube.com/watch?v=vMtt_rK4Sgg`}
              target="_blank"
              rel="noreferrer"
              style={{ marginLeft: '5px' }}
            >
              Click here to learn more.
            </a>
          </p>
        </div>
      </>,
      INTEGRATION_INSTRUCTIONS(IntegrationType.GUESTY),
    ],
    onContinue: () =>
      reverse({
        url: URLS.INTEGRATION,
        params: { company: IntegrationType.GUESTY.toLowerCase() },
      }),
  },
  guesty_lite: {
    name: IntegrationType.GUESTY_LITE,
    title: 'Get Started',
    copy: 'Learn how to connect to your Guesty Lite account with this video.',
    videos: [
      {
        id: 'Aqkjvi-VmTM',
        title: 'How it Works',
        start: 84,
      },
    ],
    heading: 'Quick-Start Instructions',
    quick_start_instructions: [
      '1) Click continue below to connect your Guesty Lite account.',
      '2) You’ll be asked for a Guesty Lite integration token. If you don’t have a token we’ll show you where to generate one.',
      '3) Paste your integration token into the provided form (required only once).',
      '4) Choose which properties you’d like to create stores for and modify stores to your liking.',
      '5) Copy your store links in the Host Co and paste them in your outgoing Guesty Lite automated messages.',
      INTEGRATION_INSTRUCTIONS(IntegrationType.GUESTY_LITE),
    ],
    onContinue: () =>
      reverse({
        url: URLS.INTEGRATION,
        params: { company: IntegrationType.GUESTY_LITE.toLowerCase() },
      }),
  },
  hostaway: {
    name: IntegrationType.HOSTAWAY,
    title: 'Get Started',
    copy: 'Learn how to connect to your Hostaway account with this video.',
    videos: [
      {
        id: '2Y5KOcYP5Us',
        title: 'How it Works',
        start: 85,
      },
    ],
    heading: 'Quick-Start Instructions',
    quick_start_instructions: [
      '1) Click continue below to connect your Hostaway account.',
      '2) You’ll be asked for a Hostaway client ID and API key. We’ll show you where to get credentials if you don’t have them.',
      '3) Paste your credentials into the provided form (required only once).',
      '4) Choose which properties you’d like to create stores for and modify stores to your liking.',
      '5) Add your store links in your outgoing Hostaway messages by hitting "+Add Variable" and selecting "listing_hostco".',
      <>
        <div>
          6) We recommend sharing your store link:
          <ul style={{ marginLeft: '30px' }}>
            <li>In your “Thanks for booking” message</li>
            <li>One week before check-in</li>
            <li>In your check-in notes</li>
            <li>For message examples, click Share on any Host Co store.</li>
          </ul>
        </div>
      </>,
      <>
        <div>
          <p style={{ marginBottom: '15px', fontWeight: 'bold' }}>
            Note on Early Check-In & Late Check-Out{' '}
          </p>{' '}
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your
          Hostaway booking times, show you a visual reminder, and add notes in your booking notes
          field, <b>unless your Host Co stores were created before May 14, 2025.</b>
          <p style={{ marginTop: '15px' }}>
            If your stores were created before this date, these early check-in and late check-out
            tiles will not sync with the Hostaway calendar because older tile versions don’t include
            the required time fields. To fix this: replace your old tiles with the updated versions.
            <a
              href={`https://www.youtube.com/watch?v=vMtt_rK4Sgg`}
              target="_blank"
              rel="noreferrer"
              style={{ marginLeft: '5px' }}
            >
              Click here to learn more.
            </a>
          </p>
        </div>
      </>,
      INTEGRATION_INSTRUCTIONS(IntegrationType.HOSTAWAY),
    ],
    bottom_heading: 'Step-by-Step Instructions',
    step_by_step_instructions: [
      '1) Click the continue button in Host Co to connect your Hostaway account.',
      '2) You’ll be asked for a Hostaway client ID and API key. Click the blue link on the Host Co pop-up, and we’ll send you to Hostaway to get your credentials. If you need to log into Hostaway first, after login, revisit the blue link in our Host Co API key pop-up to reach the correct window in Hostaway.',
      '3) Click “create” on the Hostaway Public API Screen. You can name the integration whatever you like (we recommend using Host Co so you find it easily in the future).',
      <>
        <img src={hostawayStepByStepInstructions.step1} />{' '}
      </>,
      '4) Scroll down the “partner” list looking for The Host Co. It’s about ⅔ the way down. This will generate the API key. Copy this, return to the Host Co, and paste this API key into the pop-up on the Host Co integration screen. If the API pop-up screen has closed, hit “continue” on the Host Co + Hostaway integration page to make the API screen pop up again.',
      <>
        <img src={hostawayStepByStepInstructions.step2} />{' '}
        <img src={hostawayStepByStepInstructions.step3} />{' '}
      </>,
      '5) Paste your credentials into the provided form (required only once).',
      '6) Choose which properties you’d like to create stores for and modify stores to your liking.',
      '7) Add your store links in your outgoing Hostaway messages by hitting "{ }" inside your messaging templates and selecting "listing_hostco".',
      <>
        <img src={hostawayStepByStepInstructions.step4} />
        <img src={hostawayStepByStepInstructions.step5} />
        <img src={hostawayStepByStepInstructions.step6} />
      </>,
      'To cross-reference that the link is correct, go to each property and click on custom fields - you’ll find the link there after the integration.',
      <>
        <img src={hostawayStepByStepInstructions.step7} />{' '}
      </>,
      'It can also be found under “additional info” on the listing page.',
      '8) To see templates of what other hosts say in their messages, hit “share store” on any Host CO store. We recommend sharing your Host Co store links during these times:',
      <div key="hostaway-recommendations">
        <ul className="Step_SubList" key="hostaway-recommendations-list">
          <li>In your “Thanks for booking” message</li>
          <li>One week before check-in</li>
          <li>In your check-in notes</li>
        </ul>
        <b>Note on Early Check-In & Late Check-Out</b>
        <p style={{ marginTop: '25px' }}>
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your
          Hostaway booking times, show you a visual reminder (sticky note), and add notes in your
          booking notes field, unless your Host Co stores were created before May 14, 2025. If your
          stores were created before this date, these early check-in and late check-out tiles will
          not sync with the Hostaway calendar because older tile versions don’t include the required
          time fields. To fix this, replace your old tiles with the updated versions.{' '}
          <a
            href={`https://www.youtube.com/watch?v=vMtt_rK4Sgg`}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px' }}
          >
            Click here to learn more.
          </a>
        </p>
        <b>Note on multiple accounts</b>
        <p style={{ marginTop: '25px' }}>
          Only one Host Co account can be linked to one Hostaway account. To disconnect your
          Hostaway and Host Co account, re-initiate the integration and use your new login for
          either Hostaway or The Host Co. This will update the connection to your new account and
          remove the connection from your original account. For additional help, contact
          support@thehost.co
        </p>
      </div>,
    ],
    onContinue: () =>
      reverse({
        url: URLS.INTEGRATION,
        params: { company: IntegrationType.HOSTAWAY.toLowerCase() },
      }),
  },
  lodgify: {
    name: IntegrationType.LODGIFY,
    title: 'Get Started',
    copy: 'Learn how to connect to your Lodgify account with this video.',
    videos: [
      {
        id: '1-DZDNPK1P4',
        title: 'How it Works',
        start: 84,
      },
    ],
    heading: 'Quick-Start Instructions',
    quick_start_instructions: [
      '1) Click continue below to connect your Lodgify account.',
      '2) You’ll be asked for a Lodgify API key. We’ll show you where to get credentials if you don’t have them.',
      '3) Paste your API key into the provided form (required only once).',
      '4) Choose which properties you’d like to create stores for and modify stores to your liking.',
      '5) Share your Host Co store links in your outgoing Lodgify messages.',
      <>
        <div>
          6) We recommend sharing your store link:
          <ul style={{ marginLeft: '30px' }}>
            <li>In your “Thanks for booking” message</li>
            <li>One week before check-in</li>
            <li>In your check-in notes</li>
            <li>For message examples, click Share on any Host Co store.</li>
          </ul>
        </div>
      </>,
      <>
        <div>
          <p style={{ marginBottom: '15px', fontWeight: 'bold' }}>
            Note on Early Check-In & Late Check-Out{' '}
          </p>{' '}
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your Lodgify
          booking times, show you a visual reminder, and add notes in your booking notes field,{' '}
          <b>unless your Host Co stores were created before May 14, 2025.</b>
          <p style={{ marginTop: '15px' }}>
            If yourIf your stores were created before this date, these early check-in and late
            check-out tiles will not sync with the Lodgify calendar because older tile versions
            don’t include the required time fields. To fix this: replace your old tiles with the
            updated versions.
            <a
              href={`https://www.youtube.com/watch?v=vMtt_rK4Sgg`}
              target="_blank"
              rel="noreferrer"
              style={{ marginLeft: '5px' }}
            >
              Click here to learn more.
            </a>
          </p>
        </div>
      </>,
      INTEGRATION_INSTRUCTIONS(IntegrationType.LODGIFY),
    ],
    bottom_heading: 'Step-by-Step Instructions',
    step_by_step_instructions: [
      '1) Click continue below to connect your Lodgify account.',
      '2) You’ll be asked for a Lodgify API key. Click the blue hyperlink to go to the Hostway page inside your Lodgify account.',
      '3) On the Lodgify page for The Host Co, scroll down to “copy your Lodgify API key and paste it into the partners section on the Host Co”. Click on the code in the box to automatically copy the code (if you hover over the box that says “copy API code,” it will reveal the code.',
      <>
        <img src={lodgifyStepByStepInstructions.lodgify_step1} />{' '}
        <img src={lodgifyStepByStepInstructions.lodgify_step2} />{' '}
      </>,
      '4) Go back to the Host Co Partners Page and click on Lodgify and then “continue” unless the API key box is still up on your screen. Paste your API key into the provided form (required only once)',
      '5)  Choose which stores you’d like to create stores for or connect to existing listings in your Host Co account.',
      <div key="lodgify-step5">
        <ul className="Step_SubList" key="lodgify-recommendations-list">
          <li>Update your upsells in each store with accurate prices and availability.</li>
          <li>Share your Host Co links in your outgoing Lodgify Messaging</li>
        </ul>
      </div>,
      '6) Sharing Message Templates',
      'To see templates of what other hosts are sending, click “Share Store” on any Host Co store. We recommend sharing your Host Co store links at these key moments:',
      <div key="lodgify-step6">
        <ul className="Step_SubList" key="lodgify-recommendations-list">
          <li>In your “Thanks for booking” message</li>
          <li>One week before check-in</li>
          <li>In your check-in instructions</li>
        </ul>
      </div>,
      <div key="lodgify-step7">
        <b>Note on Early Check-In & Late Check-Out</b>
        <p style={{ marginTop: '15px' }}>
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your Lodgify
          booking times, and add notes to your booking notes field—unless your Host Co stores were
          created before May 14, 2025. If your stores were created before this date, these tiles
          will not sync with the Lodgify calendar because older versions don’t include the required
          time fields. To fix this, replace your existing tiles with the updated versions.{' '}
          <a
            href={`https://www.youtube.com/watch?v=vMtt_rK4Sgg`}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px' }}
          >
            Click here to learn more.
          </a>
        </p>
      </div>,
    ],
    onContinue: () =>
      reverse({
        url: URLS.INTEGRATION,
        params: { company: IntegrationType.LODGIFY.toLowerCase() },
      }),
  },
  turno: {
    name: IntegrationType.TURNO,
    title: 'Get Started',
    copy: 'Learn how to import your Turno properties with this video.',
    videos: [
      {
        id: '2Jl6ErmIgXI',
        title: 'How it Works',
        start: 86,
      },
    ],
    heading: 'Quick-Start Instructions',
    quick_start_instructions: [
      '1) Click Connect and your Turno properties will start importing to The Host Co.',
      '2) On the next screen, choose whether to create new stores or link existing Host Co stores to the right Turno properties.',
      '3) Your new stores will auto-fill with optional alterations (like early check-in/late check-out) and popular local services.',
      '4) Once a guest books an early check-in or late check-out and it’s approved, your Turno calendar updates automatically — no manual edits needed.',
      '* For existing Host Co users: you can link your imported Turno properties with existing stores on the next page.',
      INTEGRATION_INSTRUCTIONS(IntegrationType.TURNO),
    ],
    onContinue: () => turnoApi.authenticate(),
  },
  hostfully: {
    name: IntegrationType.HOSTFULLY,
    title: 'Get Started',
    copy: 'Learn how to import your Hostfully properties with this video.',
    videos: [
      {
        id: 'Rq_sYjCiIr0',
        title: 'How it Works',
        start: 86,
      },
    ],
    heading: 'Quick-Start Instructions',
    quick_start_instructions: [
      '1) Click “continue” below to initiate the integration. On the following page, click “allow” to connect The Host Co to Hostfully.',
      <>
        <div>
          2) Once the integration has been allowed, click on the
          <a
            href={
              IS_STAGING
                ? 'https://sandbox.hostfully.com/app/#/integrations/details/thehostco'
                : 'https://platform.hostfully.com/app/#/integrations/details/thehostco'
            }
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px', marginRight: '5px' }}
          >
            Host Co Integration Page
          </a>
          (make sure you are logged in).
        </div>
      </>,
      '3) Toggle on each property you want to connect to The Host Co.',
      '4) Return to The Host Co and navigate back to Partners → Hostfully  →  Start now (this will bring you back to this instruction page with the video). Click “continue” to import your Hostfully properties into The Host Co.',
      '5) Choose whether to create new stores, link existing Host Co stores to Hostfully properties, or skip any properties you don’t want to connect. You can always come back and add more stores later.',
      'Recommended: The Host Co early check-in and late check-out tile will automatically modify your Hostfully calendar times, but if you’d like to create a visual blue dot to indicate early check-ins and late check-outs on your Hostfully calendar:',
      'I) Under Agency Settings, create a Service provider named The Host Co.',
      'II) Add two Services: early check-in and late check-out. Note: The service provider name (The Host Co) and service names must be spelled correctly to trigger the blue dots.',
      <>
        <div>
          If your Host Co stores were created before May 14, 2025: your Early Check-In and Late
          Check-Out tiles will not sync with Hostfully’s calendar, as these older tiles do not
          include the new required time fields. To fix this, you’ll need to replace your old tiles
          with the updated versions.
          <a
            href={`https://www.youtube.com/watch?v=vMtt_rK4Sggtform.hostfully.com/app/#/integrations`}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px' }}
          >
            Click here to learn more.
          </a>
          .
        </div>
      </>,
      INTEGRATION_INSTRUCTIONS(IntegrationType.HOSTFULLY),
    ],
    onContinue: () => hostfullyApi.authenticate(),
  },
};

partnersData.hosttools = {
  name: IntegrationType.HOST_TOOLS,
  title: 'Get Started',
  copy: 'Learn how to import your Host Tools properties with this video.',
  videos: [
    {
      id: 'E1rvhp7jxBU',
      title: 'How it Works',
      start: 84,
    },
  ],
  heading: 'Quick-Start Instructions',
  quick_start_instructions: [
    <ol key="part1" style={{ paddingLeft: '20px', marginBottom: '0' }}>
      <li>
        Click <strong>continue</strong> to connect your Host Tools account.
      </li>
    </ol>,

    <div key="part2" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <ol
        start="2"
        style={{ paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '12px' }}
      >
        <li>
          You’ll be asked for a HostTools integration token. If you don’t already have one, click{' '}
          <strong>API & Integrations</strong>. You’ll be taken to the HostTools integrations
          page—select <strong>The Host Co</strong> and copy your integration token.
        </li>
        <li>
          On The Host Co site, paste your integration token into the provided form (this is only
          required once).
        </li>
        <li>
          Choose how you’d like to connect your properties:
          <ul>
            <li>
              Create new Host Co stores. This creates a Host Co store for each of your HostTools
              listings.{' '}
            </li>
            <li>Link existing Host Co stores to HostTools properties</li>
            <li>
              Or skip any properties you don’t want to connect (you can always add more later)
            </li>
          </ul>
        </li>
        <li>
          Each Host Co store link automatically syncs with HostTools. Add it to your automated guest
          messages using the message tag <pre>{'{{Upsell URL}}'}</pre> to share the correct store
          with each guest.
        </li>
        <li>
          We recommend sharing your store:
          <ul>
            <li>In your “Thanks for booking” message</li>
            <li>One week before check-in</li>
            <li>In your check-in notes</li>
            <li>For message templates, click Share on any Host Co store.</li>
          </ul>
        </li>
      </ol>

      <strong>Note on Early Check-In & Late Check-Out</strong>
      <p>
        The Host Co Early Check-In and Late Check-Out tiles can automatically update your HostTools
        booking times (with your approval),{' '}
        <strong>unless your Host Co stores were created before May 14, 2025.</strong>
      </p>
      <p>
        If your stores were created before this date, these tiles will not sync with the HostTools
        calendar because older versions don’t include the required time fields.
      </p>
      <p>
        <strong>To fix this: </strong>
        replace your old tiles with the updated versions.
      </p>
      <p>
        <a href="https://www.youtube.com/watch?v=vMtt_rK4Sggtform.hostfully.com/app/#/integrations">
          Click here to learn more.
        </a>
      </p>
    </div>,
    INTEGRATION_INSTRUCTIONS(IntegrationType.HOST_TOOLS),
  ],
  onContinue: () =>
    reverse({
      url: URLS.INTEGRATION,
      params: { company: IntegrationType.HOST_TOOLS.replace(' ', '').toLowerCase() },
    }),
};

export const listPartners = [
  // Airbnb
  {
    key: 'Airbnb',
    image: airbnbLogo,
    description:
      'Automatically create stores for all of your Airbnb properties. Partnership provided by Hospitable Connect.',
    action: (history) => {
      history.push('/overview/partners/landing/hospitableconnect/');
    },
  },
  // Guesty
  {
    key: 'Guesty',
    image: guestyLogo,
    description: 'Automatically create stores for your Guesty properties.',
    action: (history) => {
      history.push('/overview/partners/landing/guesty/');
    },
  },

  // Guesty Lite
  {
    key: 'Guesty Lite',
    image: guestyLiteDarkLogo,
    description: 'Automatically create stores for your Guesty properties.',
    action: (history) => {
      history.push('/overview/partners/landing/guesty_lite/');
    },
  },

  // HOST TOOLS
  {
    key: IntegrationType.HOST_TOOLS,
    image: hosttoolsLogo,
    description: 'Automatically create stores for your Host Tools properties.',
    action: (history) => {
      history.push('/overview/partners/landing/hosttools/');
    },
  },

  // HOSTFULLY
  {
    key: IntegrationType.HOSTFULLY,
    image: hostfullyLogo,
    description: 'Automatically create stores for your Hostfully properties.',
    action: (history) => {
      history.push('/overview/partners/landing/hostfully/');
    },
  },

  // Hostaway
  {
    key: 'Hostaway',
    image: hostawayLogo,
    description: 'Automatically create stores for your Hostaway properties.',
    action: (history) => {
      history.push('/overview/partners/landing/hostaway/');
    },
  },
  // Hospitable
  {
    key: 'Hospitable',
    image: hospitableLogo,
    description: 'Automatically create stores for your Hospitable properties.',
    action: (history) => {
      history.push('/overview/partners/landing/hospitable/');
    },
  },

  // Lodgify
  {
    key: 'Lodgify',
    image: lodgifyLogo,
    description: 'Automatically create stores for your Lodgify properties.',
    action: (history) => {
      history.push('/overview/partners/landing/lodgify/');
    },
  },

  // Ownerrez
  {
    key: 'Ownerrez',
    image: ownerRezLogo,
    description: 'Automatically create stores for your OwnerRez properties.',
    action: (history) => {
      history.push('/overview/partners/landing/ownerrez');
    },
  },

  // StayFi
  {
    key: 'StayFi',
    image: stayFiLogo,
    description: 'Send guests to your Host Co Store after they log in to your StayFi Wi-Fi.',
    action: () => {
      window.open('https://www.thehost.co/stayfi', '_blank');
    },
  },

  // TouchStay
  {
    key: 'TouchStay',
    image: touchStayLogo,
    description: 'Add a Host Co store to your Touch Stay Digital Guide Book.',
    action: () => {
      window.open('https://www.thehost.co/touch-stay', '_blank');
    },
  },

  // TURNO
  {
    key: IntegrationType.TURNO,
    image: turnoLogo,
    description: 'Automatically create stores for your Turno properties.',
    action: (history) => {
      history.push('/overview/partners/landing/turno/');
    },
  },
];
